import {IPortrait, UserModel} from '@core/api/data-access';
import {withErrorState, withLoadState} from '@shared-types';

import {signalStoreDefinition} from '../';

export type UserPortraitState = IPortrait & WithLoadState & {id: string; user: UserModel};

export const UserPortraitsStore = signalStoreDefinition({
	...withLoadState,
	...withErrorState,
	portraits: {} as Record<string, UserPortraitState>,
});

export default UserPortraitsStore;
